import React, { Component } from 'react';
import { Typography, Table, Row, Button, Divider, Input, Spin, Tag, Badge, Collapse, Popconfirm, Select, message, Drawer, notification, Tooltip } from 'antd';
import { Link, Switch, Route } from 'react-router-dom';
import moment from 'moment';
import { defaultDateFormat, showErrorInNotification, THEME_COLORS, overrideHeaderBack, overrideHeaderTitle, formatMoney, NetworkDelaySearch } from '../../lib/util';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { TransparentButton } from '../../components/basic_items';
import { CloudUploadOutlined, GetAppOutlined, LayersOutlined, FlipOutlined, InsertDriveFileOutlined, StorageOutlined } from '@material-ui/icons';
import DayDifferennceTag from '../../components/day_difference_tag';


const queryString = require('query-string');


const source_label_cols = ({ datatype }) => [
  {
    title: "Source Label",
    dataIndex: 'source_label',
    key: 'source_label',
    render: (value, record) =>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        {moment().format("YYYY-MM-DD") != record.transferred_at && <div className='not-reconciled-indicator' style={{
          marginRight: 8
        }}>
        </div>}
        <Link to={{
          pathname: `/activity/data-type/${datatype}/packets/forsource`,
          search: queryString.stringify({
            transferred: 'true',
            source_id:record.source_label
          })
        }}>{value}</Link>
      </div>
  },
  {
    title: "Closing Balance",
    dataIndex: 'closing_balance',
    key: 'closing_balance',
    // width:120,
    className: 'right-align',
    render: (value) => <div style={{
      paddingRight: 16
    }}>{value == null ? "-" : formatMoney(value)}</div>
  },
  {
    title: "Queued Packets",
    dataIndex: 'untransferred_count',
    key: 'untransferred_count',
    // width:200,
    className: 'right-align',
    render: (value, record) => {
      return value > 0 ? <Link to={{
        pathname: `/activity/data-type/${datatype}/packets/forsource`,
        search: queryString.stringify({
          transferred: 'false',
          source_id:record.source_label
        })
      }}>{formatMoney(value, 0)}</Link> : (value == null ? "0" : value)
    }
  },
  {
    width: 50
  },
  {
    title: "Max Txn Date",
    dataIndex: 'max_txn_date',
    key: 'max_txn_date',
    // width:100,
    render: (value) => {
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <span>{value}</span></div>
    }
  },
  {
    title: "Last transferred",
    key: 'transferred_at',
    dataIndex: 'transferred_at',
    width: 130,
    render:(v)=><div style={{
      display:'flex',
      justifyContent:'center'
    }}>
      <DayDifferennceTag date={v} />
    </div>
    // width:200
  },

]
class SourceLabelList extends Component {
  constructor(props) {
    super(props)

    this.datatype = props.match.params.datatype_id;

    this.state = {
      filter_query: {
        per_page: 100,
        page: 1,
      },
      datatype: this.datatype,
      datatype_obj: {},
      loading: true
    };

    this.datatype_detail = RESTExecutor.detail().config({
      label: 'datatypes_details'
    }).callbacks((success) => {
      this.setState({ loading: false, datatype_obj: success.result })
      this.list_source_labels.forId(this.datatype).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();
    }, (error) => {
      showErrorInNotification(error);
      this.setState({ loading: false })
    }).forId(this.state.datatype).connect(props.domains.allData)


    this.list_source_labels = RESTExecutor.list().config({
      label: 'source_labels',
      params: {
        ...this.state.filter_query
      }
    }).forId(this.state.datatype).connect(props.domains.activity);


    this.delay_search = new NetworkDelaySearch();



    // this.list_source_labels.execute();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_source_labels_resp = this.list_source_labels.response();// this.list_datatypes.response();
    let list_source_labels_data = list_source_labels_resp.result || {};
    let datatype_detaile_resp = this.datatype_detail.response()

    if (this.state.loading) {
      return <center><Spin /></center>
    }
    let rowsData = list_source_labels_data.rows || [];
    let rowsMeta = list_source_labels_resp.meta || {};


    console.log("rows meta", rowsMeta)



    const { filter_query } = this.state;



    return (<ErrorWrapper
      error={datatype_detaile_resp}
      onReload={() => {
        this.datatype_detail.execute()
      }}
    >


      <BasicHeader
        title={this.state.datatype_obj.name}
        titleType="Datatype"
        subtitle="Source Labels"
        right={[

          <Link to={`/activity/data-type/${this.datatype}/transactions`} >
            <TransparentButton
              label="Transactions"
              icon={<StorageOutlined />}
              hint="View Transactions"
            />
          </Link>,
          <Link to={`/activity/data-type/${this.datatype}/files`} >
            <TransparentButton
              label="Files"
              icon={<InsertDriveFileOutlined />}
              hint="View Files"
            />
          </Link>,
          <Link to={`/activity/data-type/${this.datatype}/packets`} >
            <TransparentButton
              label="Packets"
              icon={<LayersOutlined />}
              hint="View Packets"
            />
          </Link>
          // <Button type='primary' onClick={() => {
          //   this.setState({
          //     upload_form_visibility: true
          //   })
          // }} style={{ margin: 4 }} icon='file' key="3">Upload File</Button>
        ]}
      />



      <ErrorWrapper
        error={list_source_labels_resp}
        onReload={() => {
          this.list_source_labels.execute()
        }}
      >
        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            // flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12,
            // paddingLeft: 8, paddingRight: 8
          }}>

            <Input.Search
              placeholder="Search For"
              style={{
              }} autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                    this.delay_search.onSearch(() => {

                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                    })

                  }
                })
              }} />
          </div>
        </div>
        <div className='default-card' style={{
          // padding: 8
        }}>
          <Table
            // rowClassName='hand-cursor'
            className='main-table noHover padder'
            loading={list_source_labels_resp.fetching}
            size='small'
            scroll={{ x: true }}
            rowClassName={(record) => {
              // console.log("record",record);
              return record.untransferred_count > 0 ? 'error-row' : ''
            }}
            pagination={{
              // simple: true,
              position: 'bottom',
              onChange: (current, size) => {
                this.props.history.push({
                  search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                })
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              defaultPageSize: 100,
              pageSize: (rowsMeta && rowsMeta.requested_count),

              total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count)} items`
            }}
            bordered={false}
            rowKey={(record) => record.parse_batch_id}
            columns={source_label_cols({
              datatype: this.datatype
            })}
            dataSource={rowsData}
          />
        </div>
      </ErrorWrapper>
    </ErrorWrapper>
    );
  }

  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.datatype_detail.execute()
      // this.list_packets.config({
      //     params: {
      //     ...this.state.filter_query
      //     }
      // }).execute()
    })
  }

  componentWillUnmount() {
    try {
      this.loading_message();
    } catch (e) {

    }
  }
  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;


    if (olddatatype_id !== newdatatype_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.datatype = newdatatype_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        },
      }, () => {
        if (olddatatype_id !== newdatatype_id) {
          this.setState({
            loading: true
          }, () => {
            this.datatype_detail.forId(this.datatype).execute()
          })
        } else {
          this.list_source_labels.forId(this.datatype).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default SourceLabelList = withDomains(SourceLabelList, "activity", "allData", "datatype");
